module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('a', {
    attrs: {
      "id": "i70"
    }
  }), _c('a', {
    attrs: {
      "id": "i129"
    }
  }), _c('a', {
    attrs: {
      "id": "i142"
    }
  }), _c('a', {
    attrs: {
      "id": "i273"
    }
  }), _c('a', {
    attrs: {
      "id": "i436"
    }
  }), _c('a', {
    attrs: {
      "id": "i463"
    }
  }), _c('a', {
    attrs: {
      "id": "i464"
    }
  }), _c('a', {
    attrs: {
      "id": "i472"
    }
  }), _c('a', {
    attrs: {
      "id": "i605"
    }
  }), _c('a', {
    attrs: {
      "id": "i610"
    }
  }), _c('a', {
    attrs: {
      "id": "i615"
    }
  }), _c('a', {
    attrs: {
      "id": "i682"
    }
  }), _c('a', {
    attrs: {
      "id": "i702"
    }
  }), _c('a', {
    attrs: {
      "id": "i705"
    }
  }), _c('a', {
    attrs: {
      "id": "i816"
    }
  }), _c('a', {
    attrs: {
      "id": "i996"
    }
  }), _c('a', {
    attrs: {
      "id": "i1065"
    }
  }), _c('a', {
    attrs: {
      "id": "i1445"
    }
  }), _c('a', {
    attrs: {
      "id": "i1451"
    }
  }), _c('a', {
    attrs: {
      "id": "i1456"
    }
  }), _c('a', {
    attrs: {
      "id": "i1495"
    }
  }), _c('a', {
    attrs: {
      "id": "i1503"
    }
  }), _c('a', {
    attrs: {
      "id": "i1634"
    }
  }), _c('a', {
    attrs: {
      "id": "i1651"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-7"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "chap2"
  }, [_vm._v("1 WE SEVEN")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("In early January 1959 I received unexpected orders to report to Washington, "), _c('a', {
    attrs: {
      "id": "i364"
    }
  }), _vm._v("D.C. At the time I was a thirty-two-year-old air force captain with twelve years of service, based at top-secret "), _c('a', {
    attrs: {
      "id": "i532"
    }
  }), _vm._v("Edwards Air Force Base in the California desert.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The best test pilots in the air force were assembled at Edwards, and I had a great job. As a test pilot in the engineering branch, I had the best of both worlds. I saw a project from the design and administrative side as well as from the pilot’s seat. I was testing and flying the nation’s top new aircraft—hot fighters like the F-102 and F-106, and the secret U-2, a reconnaissance aircraft built like a graceful glider (and not much faster than one) with an unusually long wingspan and lightweight fuselage, that could fly higher than the surface-to-air missiles of the day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A day or two before I was due to leave for Washington, I was called into the base commander’s office with three other test pilots—including one named Donald “Deke” Slayton—who had received similar orders."), _c('a', {
    attrs: {
      "id": "i73"
    }
  }), _c('a', {
    attrs: {
      "id": "i359"
    }
  }), _c('a', {
    attrs: {
      "id": "i365"
    }
  }), _c('a', {
    attrs: {
      "id": "i465"
    }
  }), _c('a', {
    attrs: {
      "id": "i533"
    }
  }), _c('a', {
    attrs: {
      "id": "i1187"
    }
  }), _c('a', {
    attrs: {
      "id": "i1423"
    }
  }), _c('a', {
    attrs: {
      "id": "i1504"
    }
  }), _c('a', {
    attrs: {
      "id": "i1546"
    }
  }), _c('a', {
    attrs: {
      "id": "i1551"
    }
  }), _c('a', {
    attrs: {
      "id": "i1619"
    }
  }), _c('a', {
    attrs: {
      "id": "i1635"
    }
  }), _c('a', {
    attrs: {
      "id": "i1711"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-8"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our commanding officer, General Marcus F. "), _c('a', {
    attrs: {
      "id": "i482"
    }
  }), _vm._v("Cooper (no relation), asked if any of us knew what our orders were about.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No, sir,” we all replied.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No one will tell me anything,” the general groused.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was a good CO, a lot better than the old-stick-in-the-mud general he’d replaced a year earlier. General Cooper remembered what it was like to be a young pilot, and he was very protective of his men as long as we did the job he asked of us.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I did see in the paper the other day,” he went on, “that "), _c('a', {
    attrs: {
      "id": "i1024"
    }
  }), _vm._v("McDonnell Aircraft has been awarded a contract for the new manned space program that’s starting up.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My ears perked up. I knew nothing about any “manned space program.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gentlemen,” General Cooper said with authority, “if this has anything to do with flying in space, I want you to be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("very careful")]), _vm._v(" what you volunteer for. I don’t want my best pilots to be involved in some idiotic program.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It had been a little over a year since that historic day in October 1957 when the Russians launched "), _c('a', {
    attrs: {
      "id": "i1593"
    }
  }), _vm._v("Sputnik, the world’s first manmade satellite. The 184-pound satellite—about the size of a basketball—could be heard by American tracking stations as it orbited Earth making a characteristic “beep-beep” sound. Residents of neighborhoods across the country waited anxiously in their yards and streets, peering into the sky at a fast-moving speck of light that was surprisingly easy to see.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had realized that Sputnik stood to open up a whole new era, and that the Soviet Union had the potential for being one up on us militarily. It reasoned that people and events on Earth could one day be observed from space. When that happened, there would be nowhere to hide.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two months later, the U.S. Navy attempted to launch the first American satellite. It was also the first nationally televised rocket launch. Upon completion of the countdown, the Vanguard rocket lifted less than a foot off the ground before the first stage, loaded "), _c('a', {
    attrs: {
      "id": "i76"
    }
  }), _c('a', {
    attrs: {
      "id": "i125"
    }
  }), _c('a', {
    attrs: {
      "id": "i766"
    }
  }), _c('a', {
    attrs: {
      "id": "i1142"
    }
  }), _c('a', {
    attrs: {
      "id": "i1188"
    }
  }), _c('a', {
    attrs: {
      "id": "i1391"
    }
  }), _c('a', {
    attrs: {
      "id": "i1424"
    }
  }), _c('a', {
    attrs: {
      "id": "i1547"
    }
  }), _c('a', {
    attrs: {
      "id": "i1620"
    }
  }), _c('a', {
    attrs: {
      "id": "i1691"
    }
  }), _c('a', {
    attrs: {
      "id": "i1712"
    }
  }), _c('a', {
    attrs: {
      "id": "i1744"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-9"
    }
  }), _vm._v("to the gills with fuel, exploded. The rest of the rocket sank in slow motion toward the ground, embedding itself in the sand next to the launch platform like a burned-out firecracker. It left an indelible image of America’s opening bid in the space race.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Were they now actually thinking of strapping a man onto a rocket?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Unbeknownst to any of us, qualifications for prospective "), _c('a', {
    attrs: {
      "id": "i121"
    }
  }), _vm._v("astronaut-pilots had been established by NASA, the newly founded civilian agency designated to lead America’s efforts in space, which had received funding from "), _c('a', {
    attrs: {
      "id": "i296"
    }
  }), _vm._v("Congress only after "), _c('a', {
    attrs: {
      "id": "i1594"
    }
  }), _vm._v("Sputnik. Although the United States did not yet have the spacecraft and other hardware necessary to send a man into space, NASA came up with a list of specific requirements to describe the kind of space pilots it was seeking.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was believed that they needed to be in their physical prime while possessing a degree of maturity to handle difficult situations. Maximum age was set at forty. Maximum height was five feet, eleven inches, an arbitrary cutoff that eliminated any number of otherwise well-qualified pilots. The spacecraft already on the drawing board had its dimensions dictated by the diameter of the available boosters—the Redstone and Atlas missiles—that would launch it into space. Those dimensions were seventy-four inches wide at the base, and it was determined that once a pilot had on helmet and pressure suit and was strapped in for liftoff, anyone six feet or taller wouldn’t be able to squeeze inside.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The weight limit was set at 180 pounds for two reasons. The first had to do with the finite (and limited) payload of the available boosters—the more a man weighed, the less room there would be for the equipment that would be necessary for a safe and successful mission. Just as important was the belief that anyone who met the height requirement but weighed more than 180 pounds would probably be overweight and therefore have a less than optimal metabolic and circulatory system to "), _c('a', {
    attrs: {
      "id": "i78"
    }
  }), _c('a', {
    attrs: {
      "id": "i122"
    }
  }), _c('a', {
    attrs: {
      "id": "i1062"
    }
  }), _c('a', {
    attrs: {
      "id": "i1143"
    }
  }), _c('a', {
    attrs: {
      "id": "i1169"
    }
  }), _c('a', {
    attrs: {
      "id": "i1312"
    }
  }), _c('a', {
    attrs: {
      "id": "i1322"
    }
  }), _c('a', {
    attrs: {
      "id": "i1329"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-10"
    }
  }), _vm._v(" handle the stresses of prolonged weightlessness and rapid changes in temperature.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The search for candidates narrowed to the ranks of practicing "), _c('a', {
    attrs: {
      "id": "i1633"
    }
  }), _vm._v("test pilots—meaning pilots from the air force, navy, and marines, along with a handful of civilians. The theory was that test pilots had the instincts and training required to handle a complex spacecraft traveling at high speeds and high altitudes. It made sense that the same men who were testing our country’s hottest jets should be in the driver’s seat when it came time to launch a manned space vehicle.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A thorough search of personnel records came up with the names of 508 test pilots who met the basic requirements. That list was reviewed further and whittled down to 110. Then a special NASA committee on life sciences, partly on the basis of confidential evaluations of candidates supplied by instructors who had taught the pilots how to fly and others who knew the quality of their nerves and reflexes, narrowed the list down further: to 69 prospective candidates, who were ordered to Washington, "), _c('a', {
    attrs: {
      "id": "i366"
    }
  }), _vm._v("D.C.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We met on February 2, 1959, in a large briefing room at NASA headquarters in downtown Washington, not far from the White House. NASA administrators and engineers spent the entire morning giving us a rundown on the space program and what part the astronauts would play.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "i1283"
    }
  }), _vm._v("Project Mercury, the free world’s first program for the manned exploration of space, was so named, we learned, for its symbolic meaning: Mercury was the winged messenger of Roman mythology. The Mercury mission was designed to explore and develop technology necessary to launch a man into orbit. We were told by a group of enthusiastic NASA officials that this would involve newly developed techniques in aerodynamics, rocket propulsion, celestial mechanics, aerospace medicine, and electronics.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gentlemen, you have an opportunity few men have even dreamed of. …”"), _c('a', {
    attrs: {
      "id": "i82"
    }
  }), _c('a', {
    attrs: {
      "id": "i438"
    }
  }), _c('a', {
    attrs: {
      "id": "i466"
    }
  }), _c('a', {
    attrs: {
      "id": "i534"
    }
  }), _c('a', {
    attrs: {
      "id": "i697"
    }
  }), _c('a', {
    attrs: {
      "id": "i769"
    }
  }), _c('a', {
    attrs: {
      "id": "i1636"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-11"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The sales pitch was on. When they got to the part about launching "), _c('a', {
    attrs: {
      "id": "i244"
    }
  }), _vm._v("chimpanzees first, there were some raised eyebrows among the fighter jocks. But we knew that if we wanted to go higher and faster and farther, as we all did, this was the way to go. And when I saw what a logical step-by-step program NASA had in mind, and what a major role the astronauts would have in it—not only as pilots but in the engineering development of the program as well—I was pretty sure I wanted in. My only doubts involved having to leave Edwards and all the fun I was having there, for a new civilian start-up program that might or might not make it.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had been flying some real high-performance airplanes and was getting up to what we then considered high altitudes and high speeds. I had the natural desire of most pilots to go higher and faster. As for space, I had long thought we ought to be trying to extend man’s capacities up there. But to have it presented as a real program, not just some Buck Rogers fiction, was quite a jolt.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Would it actually come to pass?")]), _vm._v(" I wondered."), _c('em', {
    staticClass: "italic"
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I considered what it would be like to be strapped onto the top of a big rocket and blasted off into the dark realms of space. If I volunteered and ended up being chosen for the program, would I be able to overcome the fear of the unknown and do a credible job of flying the vehicle? These were the same questions I asked myself on a regular basis as a test pilot. The real fear, for me, had always been the uncertainty of the unknown. Would I find a big surprise that I wasn’t prepared for? And if so, would I come up with a way of handling that surprise in order to preserve my life and the mission?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("At the end of the day, we were given the choice to return to our bases, no questions asked, or volunteer for continued testing. Thirty-seven men, most of them not willing to make such a radical change in their careers, dropped out of the running and returned home. Thirty-two of us volunteered to take a chance"), _c('a', {
    attrs: {
      "id": "i85"
    }
  }), _c('a', {
    attrs: {
      "id": "i367"
    }
  }), _c('a', {
    attrs: {
      "id": "i771"
    }
  }), _c('a', {
    attrs: {
      "id": "i1009"
    }
  }), _c('a', {
    attrs: {
      "id": "i1170"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-12"
    }
  }), _vm._v(" and move on to what promised to be an exhaustive series of medical examinations and "), _c('a', {
    attrs: {
      "id": "i1346"
    }
  }), _vm._v("psychological tests.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I knew some of the other pilots who were being considered, guys like Deke Slayton from Fighter Operations at Edwards, for example. Some of the "), _c('a', {
    attrs: {
      "id": "i1181"
    }
  }), _vm._v("navy guys seemed sharp too. I could see that there was going to be stiff competition for what we were told would be a dozen astronaut jobs. At that point I felt I would be lucky if I made the grade, but I wanted a chance to fly in space so much that I was determined to do my best.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The psychological tests, which came first, took many long hours and were hard work but kind of fun too. They were the sort of exams that left you not knowing how well you had done, or even if there were right or wrong answers. The psychologists seemed to be trying to measure our maturity, alertness, and judgment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There were more than five hundred questions on the "), _c('a', {
    attrs: {
      "id": "i1239"
    }
  }), _vm._v("personality inventory, designed to dig under the surface in an effort to see what kind of people we were. What was our true motivation for joining the program? Were we too egocentric to work in a team setting? In what the doctors called the “Who am I?” drill, we were asked to complete the sentence “I am …” "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("twenty times.")]), _vm._v(" The first five or six were pretty easy—“I am a man,” “I am a pilot,” “I am a father.” But before long, you had to do some serious thinking about exactly who you were—and then hope that the psychologists liked what you found.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We were divided into smaller groups for further testing, and the luck of the draw placed me in the first group of six candidates to move on in the competition. My group included a navy lieutenant commander named Al "), _c('a', {
    attrs: {
      "id": "i1471"
    }
  }), _vm._v("Shepard, who had been one of the navy’s top test pilots at Patuxent River, where the navy tested its hottest new aircraft.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next we were flown to Albuquerque, New Mexico, for strenuous "), _c('a', {
    attrs: {
      "id": "i1254"
    }
  }), _vm._v("physical examinations at the Lovelace Clinic, a newly opened private diagnostic clinic that would become the Mayo"), _c('a', {
    attrs: {
      "id": "i87"
    }
  }), _c('a', {
    attrs: {
      "id": "i252"
    }
  }), _c('a', {
    attrs: {
      "id": "i443"
    }
  }), _c('a', {
    attrs: {
      "id": "i761"
    }
  }), _c('a', {
    attrs: {
      "id": "i922"
    }
  }), _c('a', {
    attrs: {
      "id": "i1010"
    }
  }), _c('a', {
    attrs: {
      "id": "i1127"
    }
  }), _c('a', {
    attrs: {
      "id": "i1229"
    }
  }), _c('a', {
    attrs: {
      "id": "i1255"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-13"
    }
  }), _vm._v(" Clinic for space-related medical research. At this point, though, much of what they were doing was pure guesswork. The doctors got real creative, coming up with some unusual tests—such as blindfolding you and sticking a hose in your ear and pumping cold water into your ear canal. Just when you thought your eyeballs were going to float away, they would take out the hose and remove the blindfold and jot down some notes on a pad. Any questions like “What’s that for?” were met by grunts or some equally dismissive response, as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Don’t worry, you don’t need to know.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Like a bunch of lab rats, we were probed, poked, sampled, tested, and in general completely humiliated on a regular basis for the better part of a week. At one point they had us carrying a gallon jug around everywhere we went to collect a twenty-four-hour urine sample; it wasn’t long before the jars began to get real heavy. All the while, the doctors kept finding places to examine us we didn’t even know we had.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When it came out during the exams that I was bothered by hay fever, I found myself having to convince the doctors that my allergies wouldn’t pose a problem. “I can’t imagine I’ll run into many mixed grasses and sycamore trees in space,” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next came the "), _c('a', {
    attrs: {
      "id": "i1256"
    }
  }), _vm._v("physiological stress tests, at "), _c('a', {
    attrs: {
      "id": "i1776"
    }
  }), _vm._v("Wright-Patterson Air Force Base in Ohio. The doctors there—sadists to a man—knew how to separate the tigers from the pussycats. Over the course of a week, we were isolated, vibrated, whirled, heated, frozen, and fatigued.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("No one had any idea of the physical demands that space travel would place on the human body—some “experts” weren’t even sure if a man could survive the rigors of launch, and if he did, whether he would be able to swallow under zero gravity and so be able to accept fluids or food. So they did to us just about everything they could think of. And with the large pool of volunteers, they were free to be deliberately brutal, as I think they were, in an attempt to weed out the candidates."), _c('a', {
    attrs: {
      "id": "i91"
    }
  }), _c('a', {
    attrs: {
      "id": "i374"
    }
  }), _c('a', {
    attrs: {
      "id": "i439"
    }
  }), _c('a', {
    attrs: {
      "id": "i467"
    }
  }), _c('a', {
    attrs: {
      "id": "i473"
    }
  }), _c('a', {
    attrs: {
      "id": "i535"
    }
  }), _c('a', {
    attrs: {
      "id": "i606"
    }
  }), _c('a', {
    attrs: {
      "id": "i611"
    }
  }), _c('a', {
    attrs: {
      "id": "i1257"
    }
  }), _c('a', {
    attrs: {
      "id": "i1637"
    }
  }), _c('a', {
    attrs: {
      "id": "i1652"
    }
  }), _c('a', {
    attrs: {
      "id": "i1777"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-14"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They put each of us into a tub of ice and water for an hour. As I settled in, I sighed, “Oh boy, this is just like trout fishing back home in the mountains.” A technician nearby raised an eyebrow and made a notation on his pad that I liked it. When I went into an ovenlike room to be baked at 160 degrees for an hour, I purred, “Oh my, I’m back on the desert. This is the temperature we fly in all the time at Edwards.” Another white coat noted that I liked the heat. When they put me in a tiny dark box to test for claustrophobia and fear of isolation, I fell asleep.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They had us run in a chamber simulating high altitude while wearing a partial pressure suit, and a number of volunteers dropped out of the competition at this stage. I had an advantage over some of the others because I had experience wearing one of these contraptions at Edwards. By regulation they were worn by pilots who expected to go above fifty thousand feet—which included the aircraft I flew, like the U-2, F-102, and F-106—in case there was an emergency cabin depressurization. They were designed to keep the pilot alive—breathing, with proper blood flow through the body—until he was able to get down to a lower altitude. The old partial suits—forerunners of the more pilot-friendly full "), _c('a', {
    attrs: {
      "id": "i1265"
    }
  }), _vm._v("pressure suits that were developed for space flights—had capstans, or tubes filled with air, at different places along the legs, arms, and torso. As you went higher, the capstans would inflate, grabbing and pinching chunks of skin and hair as they did.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the altitude chamber, which we dubbed the torture chamber, they ran us up to the equivalent of a hundred thousand feet. In a partial suit, breathing was the opposite of what you were accustomed to. To inhale, you relaxed and your lungs would fill up effortlessly. Exhaling was another matter. The only way to empty your lungs was to forcefully exhale with all your might. The process got exhausting pretty quickly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("By the time I returned to Edwards, I was confident I had made the grade. Even though I’d heard that the field of "), _c('a', {
    attrs: {
      "id": "i123"
    }
  }), _c('a', {
    attrs: {
      "id": "i331"
    }
  }), _c('a', {
    attrs: {
      "id": "i383"
    }
  }), _c('a', {
    attrs: {
      "id": "i422"
    }
  }), _c('a', {
    attrs: {
      "id": "i430"
    }
  }), _c('a', {
    attrs: {
      "id": "i490"
    }
  }), _c('a', {
    attrs: {
      "id": "i517"
    }
  }), _c('a', {
    attrs: {
      "id": "i536"
    }
  }), _c('a', {
    attrs: {
      "id": "i878"
    }
  }), _c('a', {
    attrs: {
      "id": "i1144"
    }
  }), _c('a', {
    attrs: {
      "id": "i1577"
    }
  }), _c('a', {
    attrs: {
      "id": "i1730"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-15"
    }
  }), _vm._v("c"), _c('a', {
    attrs: {
      "id": "i315"
    }
  }), _c('a', {
    attrs: {
      "id": "i397"
    }
  }), _c('a', {
    attrs: {
      "id": "i748"
    }
  }), _vm._v("andidates was going to be narrowed and they would be picking only six or seven astronauts rather than a dozen, I suggested to my immediate supervisor that he ought to start looking for my replacement because I was about to be chosen as an astronaut. I knew about how long it would take for the remaining candidates to be tested, and I was not surprised when the phone call came in early April. In fact, at the first ring I had a strange feeling this was the call I’d been waiting for.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I’m ready,"), _c('a', {
    attrs: {
      "id": "i549"
    }
  }), _vm._v("” I said, not waiting to hear the caller’s identity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It turned out to be the assistant manager for Project Mercury, Charles "), _c('a', {
    attrs: {
      "id": "i521"
    }
  }), _vm._v("Donlon, whom I had met in Washington.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He chuckled. “You still interested in being an astronaut?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Yes, sir, I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He wanted to know when I could leave for "), _c('a', {
    attrs: {
      "id": "i984"
    }
  }), _vm._v("Langley Air Force Base in Virginia, where Project Mercury had its headquarters.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“How about right now?” I said.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Next Monday will be fine.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One other pilot from Edwards, Deke "), _c('a', {
    attrs: {
      "id": "i1513"
    }
  }), _vm._v("Slayton, had also made the grade.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There was an additional unspoken requirement for selection: NASA wanted only happily married family men as America’s first astronauts. The main reason was a public relations one, although there was also a theory that marital unhappiness could lead to a pilot making a wrong decision that might cost lives—his own and others.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("This happily-ever-after business posed a problem for me, because my wife, Trudy, and I had been separated and living apart for some time. I had been living in bachelor quarters at Edwards, and she was in San Diego with our two daughters, then eleven and nine. We had discussed getting back together for the kids but had made no decision.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When the topic of my twelve-year marriage came up during the interview process, I pretended everything was fine and dandy. Yep, couldn’t be better. I knew that a phone call or two"), _c('a', {
    attrs: {
      "id": "i124"
    }
  }), _c('a', {
    attrs: {
      "id": "i348"
    }
  }), _c('a', {
    attrs: {
      "id": "i375"
    }
  }), _c('a', {
    attrs: {
      "id": "i423"
    }
  }), _c('a', {
    attrs: {
      "id": "i450"
    }
  }), _c('a', {
    attrs: {
      "id": "i491"
    }
  }), _c('a', {
    attrs: {
      "id": "i498"
    }
  }), _c('a', {
    attrs: {
      "id": "i879"
    }
  }), _c('a', {
    attrs: {
      "id": "i1145"
    }
  }), _c('a', {
    attrs: {
      "id": "i1204"
    }
  }), _c('a', {
    attrs: {
      "id": "i1294"
    }
  }), _c('a', {
    attrs: {
      "id": "i1330"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-16"
    }
  }), _vm._v(" could put an end to my charade, so as soon as I had a chance I made a quick trip to San Diego to talk to Trudy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I told her about my opportunity to be selected as an astronaut, explaining that I would retain my military rank and pay while on special assignment to the new civilian space agency. We discussed what the space program might mean for the astronauts and families alike. Trudy, a licensed pilot herself, caught my enthusiasm. We agreed that it could be an adventure for us all and that a reconciliation was called for in order for me to remain a viable candidate for the program. We were soon back living together under one roof.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As far as NASA was concerned, we had never been separated and had an all-American marriage. Trudy and I would both struggle with the “happily married” illusion through the years. Eventually I spent most of my time away from home except when I scheduled things to do with the children. (Other astronauts had similar problems; only three Mercury astronauts were to remain in first marriages.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The "), _c('a', {
    attrs: {
      "id": "i1075"
    }
  }), _vm._v("“Mercury Seven” were introduced at a Washington, D.C., press conference on April 9, 1959. Three were from the air force, three from the navy, and one from the Marine Corps. It had been only three months since sixty-nine of us first gathered in a NASA briefing room to learn about the new manned space program.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Our coming-out party was no small affair—the largest auditorium at NASA headquarters was packed wall to wall with several hundred newspeople.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Dr. T. Keith "), _c('a', {
    attrs: {
      "id": "i833"
    }
  }), _vm._v("Glennan, NASA administrator, got up on the stage, where the seven of us—wearing civilian suits—were seated in alphabetical order behind a long table. Each of us had a name plate and microphone in front of him.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Ladies and gentlemen, today we are introducing to you and to the world these seven men who have been selected to begin training for orbital space flight. These men are here after "), _c('a', {
    attrs: {
      "id": "i3"
    }
  }), _c('a', {
    attrs: {
      "id": "i419"
    }
  }), _c('a', {
    attrs: {
      "id": "i424"
    }
  }), _c('a', {
    attrs: {
      "id": "i746"
    }
  }), _c('a', {
    attrs: {
      "id": "i765"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-17"
    }
  }), _vm._v(" a long and unprecedented series of evaluations which told our medical consultants and scientists of their superb adaptability to their upcoming flight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is my pleasure,” "), _c('a', {
    attrs: {
      "id": "i807"
    }
  }), _c('a', {
    attrs: {
      "id": "i834"
    }
  }), _vm._v("Glennan went on, “to introduce to you—and I consider it a very real honor—the nation’s Mercury astronauts!")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Malcolm S. "), _c('a', {
    attrs: {
      "id": "i218"
    }
  }), _vm._v("Carpenter.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“L. Gordon "), _c('a', {
    attrs: {
      "id": "i489"
    }
  }), _vm._v("Cooper, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“John H. Glenn, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Virgil I. "), _c('a', {
    attrs: {
      "id": "i849"
    }
  }), _vm._v("Grissom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Walter M. "), _c('a', {
    attrs: {
      "id": "i1437"
    }
  }), _vm._v("Schirra, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Alan B. "), _c('a', {
    attrs: {
      "id": "i1472"
    }
  }), _vm._v("Shepard, Jr.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Donald K. "), _c('a', {
    attrs: {
      "id": "i1514"
    }
  }), _vm._v("Slayton.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Applause erupted throughout the room as reporters and photographers stood, putting down their notebooks and cameras in order to clap vigorously with both hands. The applause continued for a surprising length of time. Some of us grinned sheepishly at each other.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("It’s as if we have already done something,")]), _vm._v(" I thought. All we had done was have our names on a list and take some tests. We hadn’t even flown a mission yet.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first question directed at us by a reporter threw most of us for a loop. It wasn’t about our military or flying backgrounds; he wanted to hear from each of us what our wives and children had to say about our being selected as astronauts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I don’t remember what I said. Whatever I mouthed, it came from behind the mask of a career officer; a few platitudes, then shutting up and hoping like hell that no one knew the truth about my marriage.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After I finished, it was John Glenn’s turn. He jumped on the question like a hungry mountain lion that had just spotted dinner: “I don’t think any of us could really go on with something like this if we didn’t have pretty good backing at home, really. My wife’s attitude toward this has been the same as it has"), _c('a', {
    attrs: {
      "id": "i93"
    }
  }), _c('a', {
    attrs: {
      "id": "i451"
    }
  }), _c('a', {
    attrs: {
      "id": "i1205"
    }
  }), _c('a', {
    attrs: {
      "id": "i1295"
    }
  }), _c('a', {
    attrs: {
      "id": "i1318"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-18"
    }
  }), _vm._v(" been all al"), _c('a', {
    attrs: {
      "id": "i1399"
    }
  }), _vm._v("ong through my flying. If it is what I want to do, she is behind it, and the kids are too, a hundred percent. …”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I looked at "), _c('a', {
    attrs: {
      "id": "i808"
    }
  }), _vm._v("Glenn and smiled, thinking, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Who")]), _vm._v(" is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("this Boy Scout?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was a freckle-faced Tom Sawyer type with a sunny smile who, I quickly came to realize, was awfully good at charming his way in or out "), _c('a', {
    attrs: {
      "id": "i1376"
    }
  }), _vm._v("of about any situation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I was mighty glad that I came before and not after Glenn, like my old buddy Gus "), _c('a', {
    attrs: {
      "id": "i850"
    }
  }), _vm._v("Grissom, with whom I had attended some air force schools and done some hunting and flying in our spare time. Gus was not one to waste words, and each time he had to field the same question right after Glenn had scored about every point imaginable with it, poor Gus came off as distinctly inarticulate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of the next questions to the group was about religion. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("When are we going to get some questions about flying and space exploration?")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was as if John Glenn had been waiting for the religion question all along. He uncorked a spiel about God, country, his experiences teaching Sunday school and being on church boards, and a bunch of other saintly stuff that the press ate up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("And when he was finished, it was Gus’s turn.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned to look at Gus, who seemed to be suffering from indigestion.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I am not real active in church, as Mr. Glenn is.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Poor Gus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So it went for two hours as we sat under the glaring TV spotlights and answered questions from the news media. I was startled and made uncomfortable by all the attention, as were most of the guys. Up to then we had been anonymous military pilots at midcareer. It was a taste of what the next several years would be like. We woke up the next morning on the front pages of newspapers, and shortly thereafter on the covers of national magazines. From then on we were never anonymous again."), _c('a', {
    attrs: {
      "id": "i136"
    }
  }), _c('a', {
    attrs: {
      "id": "i267"
    }
  }), _c('a', {
    attrs: {
      "id": "i734"
    }
  }), _c('a', {
    attrs: {
      "id": "i860"
    }
  }), _c('a', {
    attrs: {
      "id": "i1081"
    }
  }), _c('a', {
    attrs: {
      "id": "i1156"
    }
  }), _c('a', {
    attrs: {
      "id": "i1552"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-19"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After that, we were thankful to get to work at NASA—astronauts, technicians, scientists, and administrators, all on a first-name basis—to get America into the space race with the Soviets, who had a big head start. There wasn’t a man among us who didn’t feel we could overcome that lead, but it would take a lot of work and some luck along the way.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So much of what had to be done before the first manned mission could be launched had never been attempted before. NASA engineers were busy coming up with new guidance systems for rockets and new ways to monitor temperature, pressure, oxygen, and other vital conditions aboard the spacecraft—the technology was nothing short of pioneering.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We seven traveled the country—together at times, often separately—to visit defense contractors working on different aspects of the program. At the plant that was building our electronics for the rocket booster, we showed workers how to build a clean room, free of dirt, debris, and "), _c('a', {
    attrs: {
      "id": "i1529"
    }
  }), _vm._v("solder balls. In fact, some of the early Atlas rocket failures turned out to have been caused by errant solder balls—shaken loose by the tremendous vibrations during liftoff—that shorted out the guidance package, causing the rocket to veer off course. Soldering techniques had to be changed for all space-related work.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We came up with a "), _c('a', {
    attrs: {
      "id": "i1090"
    }
  }), _vm._v("Mercury stamp—the Greek symbol for Mercury with the number 7 inside it. Any part destined for the manned program, no matter how small, received the stamp—meaning that everyone from the designers to the assembly line workers realized that a man’s life depended on the quality of their work. Our message was the same wherever we went: “Do good work. A man’s life is riding on you.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The astronaut office at "), _c('a', {
    attrs: {
      "id": "i985"
    }
  }), _vm._v("Langley Air Force Base in Virginia, where NASA was headquartered, consisted of one big office with eight desks: one for each astronaut and one for our crackerjack secretary, Nancy "), _c('a', {
    attrs: {
      "id": "i1015"
    }
  }), _vm._v("Lowe, who was only seventeen years old and just starting her twenty-five-year NASA career. Nancy was"), _c('a', {
    attrs: {
      "id": "i421"
    }
  }), _c('a', {
    attrs: {
      "id": "i755"
    }
  }), _c('a', {
    attrs: {
      "id": "i1016"
    }
  }), _c('a', {
    attrs: {
      "id": "i1080"
    }
  }), _c('a', {
    attrs: {
      "id": "i1082"
    }
  }), _c('a', {
    attrs: {
      "id": "i1420"
    }
  }), _c('a', {
    attrs: {
      "id": "i1641"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-20"
    }
  }), _vm._v(" extremely well organized and could type more than a hundred words a minute. She handled all our letters and reports, and it was a real workload, with seven bosses, each of whom considered himself a leader—seven alpha males in the same pack.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Lots of time was spent kicking things around in that office, discussing and evaluating, quietly agreeing and loudly disagreeing, until we came up with a consensus. When a decision came out of the astronaut office, where there were only seven votes possible, it was always a single decision. There were no minority and majority decisions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One of our most lively debates had to do with whether or not the spacecraft should have rudder pedals like an airplane to control its "), _c('a', {
    attrs: {
      "id": "i1783"
    }
  }), _vm._v("yaw, or side-to-side motion. In an aircraft, the yaw was controlled with rudder pedals and the pitch and roll were on the control stick. Deke "), _c('a', {
    attrs: {
      "id": "i1515"
    }
  }), _vm._v("Slayton and I felt that we should keep the "), _c('a', {
    attrs: {
      "id": "i323"
    }
  }), _vm._v("control system we were most familiar with and have rudder pedals installed. Why make us fly the spacecraft differently than we had flown planes for years? But four of the guys felt very strongly that the rudder pedals would take up room at our feet and add to the complexity of flight-system installation. They wanted to put all three axis controls on the flight stick. Wally "), _c('a', {
    attrs: {
      "id": "i1438"
    }
  }), _vm._v("Schirra could see benefits to both, and rode the fence on the issue. The engineers just shrugged—they could go either way, and left the final decision up to those of us who would be doing the flying. We all did a lot of soul-searching, and Deke and I were finally convinced to go with the three-axis control stick. It was the right decision.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We weren’t just mouthpieces or pilots milling around a hangar waiting to fly. We were involved in all aspects of the program, and there was a job for everybody.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Scott "), _c('a', {
    attrs: {
      "id": "i219"
    }
  }), _vm._v("Carpenter took on "), _c('a', {
    attrs: {
      "id": "i262"
    }
  }), _vm._v("communications and navigational aids, something he’d done in the navy. An intense and sensitive guy, Scott had a bit of poet in him and spent a lot of time thinking about and discussing the larger ramifications of space flight"), _c('a', {
    attrs: {
      "id": "i223"
    }
  }), _c('a', {
    attrs: {
      "id": "i599"
    }
  }), _c('a', {
    attrs: {
      "id": "i830"
    }
  }), _c('a', {
    attrs: {
      "id": "i912"
    }
  }), _c('a', {
    attrs: {
      "id": "i1189"
    }
  }), _c('a', {
    attrs: {
      "id": "i1225"
    }
  }), _c('a', {
    attrs: {
      "id": "i1266"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-21"
    }
  }), _vm._v(" and what it might mean for mankind. In terms of his flying background, most of his time was in large propeller aircraft, with limited jet hours, which in this group of hotshot fighter jocks made him the odd man out at times. He was a great swimmer and diver, and the best dancer of the group—he did a mean Twist.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Al "), _c('a', {
    attrs: {
      "id": "i1473"
    }
  }), _vm._v("Shepard had experience with ships and knew a lot of navy brass from his naval career, so he concentrated on the worldwide tracking range and assembling the "), _c('a', {
    attrs: {
      "id": "i1382"
    }
  }), _vm._v("recovery teams we would need to pull us out of the water after a flight. In some ways Al was the most complex of the original astronauts. He seemed to have two distinct personalities, one the charming and beguiling jokester who introduced José Jimenez—comedian Bill "), _c('a', {
    attrs: {
      "id": "i508"
    }
  }), _vm._v("Dana’s popular alter ego—and his “Please don’t send me” astronaut act into our everyday lives; the other that came out when the chips were down and was so competitive as to be ruthless. We all knew to watch our backs when "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that")]), _vm._v(" Al was around.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John "), _c('a', {
    attrs: {
      "id": "i809"
    }
  }), _vm._v("Glenn of the marines had been involved in aircraft design and was a natural to work on "), _c('a', {
    attrs: {
      "id": "i254"
    }
  }), _vm._v("cockpit layout and design of the instrument panel in the spacecraft. The oldest of the astronauts at thirty-seven, John had set a transcontinental speed record two years earlier in an F-8 Crusader. John would turn out to be a great and loyal friend, even if he was our “clean marine.” We all knew he was destined for politics; we figured that one day he would be president. He was the only Mercury astronaut not to move his family to Langley Air Force Base. He kept his wife and two children in Washington, D.C. Whenever he went home, he made a point to visit all the NASA bigwigs and various congressional officials. As I said, John was a born politician.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("NASA decided we would use a highly modified version of the U.S. Navy pressure suit for our space flights, so Wally "), _c('a', {
    attrs: {
      "id": "i1439"
    }
  }), _vm._v("Schirra, a navy man and Annapolis graduate, started work on adapting the life-support system that would be needed to keep the pilot alive and comfortable. Wally was outgoing and congenial and loved to make people laugh, but he was formidable"), _c('a', {
    attrs: {
      "id": "i126"
    }
  }), _c('a', {
    attrs: {
      "id": "i282"
    }
  }), _c('a', {
    attrs: {
      "id": "i388"
    }
  }), _c('a', {
    attrs: {
      "id": "i468"
    }
  }), _c('a', {
    attrs: {
      "id": "i537"
    }
  }), _c('a', {
    attrs: {
      "id": "i667"
    }
  }), _c('a', {
    attrs: {
      "id": "i780"
    }
  }), _c('a', {
    attrs: {
      "id": "i1350"
    }
  }), _c('a', {
    attrs: {
      "id": "i1367"
    }
  }), _c('a', {
    attrs: {
      "id": "i1392"
    }
  }), _c('a', {
    attrs: {
      "id": "i1443"
    }
  }), _c('a', {
    attrs: {
      "id": "i1505"
    }
  }), _c('a', {
    attrs: {
      "id": "i1573"
    }
  }), _c('a', {
    attrs: {
      "id": "i1638"
    }
  }), _c('a', {
    attrs: {
      "id": "i1705"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-22"
    }
  }), _vm._v(" when the time came and could focus with engineer-like tenacity on the technical intricacies of space flight.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gus "), _c('a', {
    attrs: {
      "id": "i851"
    }
  }), _vm._v("Grissom, who had experience in technical engineering, was assigned to help develop the automatic and manual "), _c('a', {
    attrs: {
      "id": "i324"
    }
  }), _vm._v("control systems we would use to fly the spacecraft. Gus was my closest friend in the astronaut corps. We had been classmates at the "), _c('a', {
    attrs: {
      "id": "i30"
    }
  }), _vm._v("Air Force Institute of Technology in Ohio and test pilot school at Edwards, and he was a heck of a nice guy, with whom I enjoyed working and playing. He was a little bear of a man and a country boy at heart, but when it came to flying he was steady and no-nonsense. Of all the astronauts, Gus would have been my first choice to fly my wing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Deke "), _c('a', {
    attrs: {
      "id": "i1516"
    }
  }), _vm._v("Slayton, the other air force “blue suit” in the mix, was an experienced engineering test pilot who knew the technical details of his job thoroughly. He pitched in to study the Atlas rocket, which we would use for the first orbital missions. I had flown with Deke at Edwards and knew him to be a capable pilot. When it came to the space program, his ability to analyze a complex problem and articulate his ideas about it made him an invaluable member of the team.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As for me, I considered myself a pretty good stick-and-rudder man. Controlling an aircraft was what I did best in life. Flying came as naturally as breathing and eating to me, and if I sometimes acted as if I didn’t think anyone could outdo me in the air, well, that’s how I felt. Modesty is not the best trait for a fighter pilot. The meek do not inherit the sky.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Since I had a lot of propulsion work in my background, I headed out to the "), _c('a', {
    attrs: {
      "id": "i113"
    }
  }), _vm._v("Army Redstone Arsenal in Huntsville, Alabama, to learn more about the "), _c('a', {
    attrs: {
      "id": "i1410"
    }
  }), _vm._v("rocket boosters we would use for the two suborbital flights. My work there ran the gamut: configuration, trajectory, aerodynamics, countdown and flight procedures. The Redstone was really an improved V-2, the rocket the Germans had used for blitzing London during the war. The designer of the"), _c('a', {
    attrs: {
      "id": "i114"
    }
  }), _c('a', {
    attrs: {
      "id": "i284"
    }
  }), _c('a', {
    attrs: {
      "id": "i369"
    }
  }), _c('a', {
    attrs: {
      "id": "i687"
    }
  }), _c('a', {
    attrs: {
      "id": "i781"
    }
  }), _c('a', {
    attrs: {
      "id": "i1083"
    }
  }), _c('a', {
    attrs: {
      "id": "i1212"
    }
  }), _c('a', {
    attrs: {
      "id": "i1333"
    }
  }), _c('a', {
    attrs: {
      "id": "i1393"
    }
  }), _c('a', {
    attrs: {
      "id": "i1411"
    }
  }), _c('a', {
    attrs: {
      "id": "i1610"
    }
  }), _c('a', {
    attrs: {
      "id": "i1706"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-23"
    }
  }), _vm._v(" V-2, Dr. Wemher von "), _c('a', {
    attrs: {
      "id": "i176"
    }
  }), _vm._v("Braun, who came to the United States after the war, was now a key player in our space program. Making the boosters compatible with our spacecraft would take coordination and communication between several civilian contractors, the military, and NASA. As an engineer, I could talk the language of other engineers. And since I was hoping to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ride")]), _vm._v(" the finished product, I really got immersed in the problems and had a keen interest in seeing that everything went smoothly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("So we all had our jobs to do, and the work was parceled out evenly among the seven of us. For the next twenty-one months, we each went our own way, trying to learn everything about our specialty, then reporting back to the others at regular intervals.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We also spent a lot of time training in the flight simulator and "), _c('a', {
    attrs: {
      "id": "i230"
    }
  }), _vm._v("centrifuge. They once took me up to 18 Gs in the centrifuge—meaning that I weighed eighteen times my normal 150 pounds, or approximately 2,700 pounds. It felt as if a Mack truck had been parked on my chest, making it extremely hard to breathe. The biomedical people were testing the limits of human tolerance, trying to figure out at what point an astronaut would go into unconsciousness, caused by gravity preventing blood getting to the brain. This happened much more quickly, we found, when the pilot was sitting upright, when there was further vertical distance between the heart and the brain—information that went into the design of our flight couches, which allowed the astronaut to be lying down during times of heavy G loads, such as launch and reentry. At 18 Gs I had still been able to answer a light signal and push buttons, but just barely. I lost my vision almost completely, and I stepped away wet with blood from broken capillaries up and down my arms, legs, and back. The only thing that could be done for me was to douse the cuts with alcohol to ward off infection. I was sore and black and blue for a couple of weeks. After that they decided not to exceed 15 Gs in training. That was plenty, given that 8 to 10 Gs were thought to be the"), _c('a', {
    attrs: {
      "id": "i231"
    }
  }), _c('a', {
    attrs: {
      "id": "i370"
    }
  }), _c('a', {
    attrs: {
      "id": "i607"
    }
  }), _c('a', {
    attrs: {
      "id": "i712"
    }
  }), _c('a', {
    attrs: {
      "id": "i753"
    }
  }), _c('a', {
    attrs: {
      "id": "i920"
    }
  }), _c('a', {
    attrs: {
      "id": "i1151"
    }
  }), _c('a', {
    attrs: {
      "id": "i1155"
    }
  }), _c('a', {
    attrs: {
      "id": "i1303"
    }
  }), _c('a', {
    attrs: {
      "id": "i1334"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-24"
    }
  }), _vm._v(" maximum load under normal flight conditions. Eventually it was decided that 11 to 14 Gs was the maximum load at which a man could handle an intricate control problem.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One part of our training that was being overlooked was flying, and none of us were happy about it. We were doing a lot of commercial flying, going from city to city on our various NASA assignments, waiting at air terminals and claiming our luggage like any other passengers. We were fighter pilots and we longed to get back to flying. We saw a dual purpose: we’d get where we needed to be quicker while keeping up our proficiency. But NASA had no jets of its own, and although we had repeatedly asked that something be done about this oversight, our request hadn’t made it to the top of any administrator’s priority list.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One day, New York "), _c('a', {
    attrs: {
      "id": "i297"
    }
  }), _vm._v("Congressman Jim "), _c('a', {
    attrs: {
      "id": "i715"
    }
  }), _vm._v("Fulton, known for ferreting things out, showed up at Langley. I went to lunch with him. He wanted to know all about how our training was going, then asked, “And what about flying?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I told him the truth. “We’re not flying. We don’t have any planes.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It was so bad, I said, that in order for us to keep our flight pay—an extra $145 a month, which required at least four hours of in-command flight time per month—we had been going out to Langley and getting in line behind deskbound colonels and generals who were trying to keep their flight pay too.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The congressman seemed shocked. “But I thought flying was a big part of an astronaut’s training.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“It is,” I said. “Or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("should")]), _vm._v(" be.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The next day, the "), _c('a', {
    attrs: {
      "id": "i901"
    }
  }), _vm._v("House Committee on Science and Astronautics began an investigation into why the astronauts weren’t flying. The higher-ups at NASA were none too happy, but my fellow astronauts were delighted. Within weeks we had our own F-102s—on loan to NASA from the "), _c('a', {
    attrs: {
      "id": "i14"
    }
  }), _vm._v("air force. We had some single-seaters and a two-seater. The F-102 was great for us because, while it was a hot plane, it could get in and out of the"), _c('a', {
    attrs: {
      "id": "i5"
    }
  }), _c('a', {
    attrs: {
      "id": "i250"
    }
  }), _c('a', {
    attrs: {
      "id": "i578"
    }
  }), _c('a', {
    attrs: {
      "id": "i608"
    }
  }), _c('a', {
    attrs: {
      "id": "i1084"
    }
  }), _c('a', {
    attrs: {
      "id": "i1152"
    }
  }), _c('a', {
    attrs: {
      "id": "i1267"
    }
  }), _c('a', {
    attrs: {
      "id": "i1342"
    }
  }), _c('a', {
    attrs: {
      "id": "i1369"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-25"
    }
  }), _vm._v(" shorter civilian airfields that we needed to go to and required only light maintenance.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In any research and development program where the state-of-the-art is being pressed forward, there are always unknowns—the what-if factor. Project Mercury, with its purpose to investigate man’s capabilities in space, was such a program.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Extreme efforts were made to ensure operating reliability in the interest of mission success and pilot safety. But we were dealing with mechanical, manmade pieces of equipment, which even in the most ideal situations were subject to malfunction. For this reason, many redundant or "), _c('a', {
    attrs: {
      "id": "i146"
    }
  }), _vm._v("backup systems were built into the Mercury spacecraft and related equipment. From prelaunch until safe recovery, hundreds of different possible contingencies were anticipated. A few examples:")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("IF")]), _vm._v(" an impending catastrophic failure was indicated between liftoff and escape tower separation (which pulled the spacecraft away from the booster about 140 seconds after launch), the automatic "), _c('a', {
    attrs: {
      "id": "i1"
    }
  }), _vm._v("abort-sensing and implementation system (ASIS) could automatically initiate an escape sequence to remove the spacecraft from the booster, or the escape system could be fired by ground command from the blockhouse, or by ground command from the "), _c('a', {
    attrs: {
      "id": "i1063"
    }
  }), _vm._v("Mercury Control Center, or by the astronaut in the cockpit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("IF")]), _vm._v(" the spacecraft did not automatically separate from the launch vehicle at booster burnout, separation could be initiated by ground command or by the astronaut, who could initiate separation manually from the cockpit.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("IF")]), _vm._v(" the spacecraft pressure vessel developed a leak during flight, the astronaut’s full pressure suit would automatically inflate to five pounds per square inch to provide a second closed environment.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("IF")]), _vm._v(" the system that provided oxygen to the astronaut’s suit failed, an emergency supply would automatically cut into the circuit, or the astronaut could start the alternate system."), _c('a', {
    attrs: {
      "id": "i757"
    }
  }), _c('a', {
    attrs: {
      "id": "i1085"
    }
  }), _c('a', {
    attrs: {
      "id": "i1092"
    }
  }), _c('a', {
    attrs: {
      "id": "i1331"
    }
  }), _c('a', {
    attrs: {
      "id": "i1335"
    }
  }), _c('a', {
    attrs: {
      "id": "i1343"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-26"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("IF")]), _vm._v(" the astronaut’s primary ultrahigh-frequency voice link with the ground tracking network failed, he could switch to a second UHF or a high-frequency channel.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("IF")]), _vm._v(" the astronaut’s microphone failed, a second mike in parallel with the first would automatically begin to operate.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("IF")]), _vm._v(" all voice link systems failed, the astronaut could resort to a Morse code key in the cockpit and use the telemetry transmitters and frequencies to send messages back to the tracking network.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After designing and installing these "), _c('a', {
    attrs: {
      "id": "i147"
    }
  }), _vm._v("backup systems and hundreds more like them, we believed, finally, that we were ready to go.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("On January 19, 1961, the day before the inauguration of President John F. "), _c('a', {
    attrs: {
      "id": "i948"
    }
  }), _vm._v("Kennedy, who would have so much to do with getting Americans into space and to the Moon, NASA director Robert "), _c('a', {
    attrs: {
      "id": "i796"
    }
  }), _vm._v("Gilruth met with the seven of us in the astronaut office. What he was about to tell us, he cautioned, had to be kept in the strictest confidence.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Previously we had been told that all seven of us would undergo the same exact training, and that on the eve of the first manned flight, the name of the astronaut who would take the flight would be announced to us and the world. Gilruth now said he had thought better of that—it stood to reason that the prime pilot should have preference on the "), _c('a', {
    attrs: {
      "id": "i688"
    }
  }), _vm._v("flight simulators and in other aspects of training. At the same time, he didn’t want to put unnecessary public pressure on the prime pilot. So it had been decided to go ahead and select the prime pilot for the first mission, scheduled to be flown in four months, and also two backup pilots. The press and public would be given the three names and told only that the prime pilot would be one of these three men.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“This has been a difficult decision,” Gilruth said. “All seven of you have worked long and hard. Any one of you would make a capable pilot for the first flight.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We all wanted him to just spit it out. All of us would have "), _c('a', {
    attrs: {
      "id": "i245"
    }
  }), _c('a', {
    attrs: {
      "id": "i460"
    }
  }), _c('a', {
    attrs: {
      "id": "i814"
    }
  }), _c('a', {
    attrs: {
      "id": "i854"
    }
  }), _c('a', {
    attrs: {
      "id": "i869"
    }
  }), _c('a', {
    attrs: {
      "id": "i986"
    }
  }), _c('a', {
    attrs: {
      "id": "i1033"
    }
  }), _c('a', {
    attrs: {
      "id": "i1086"
    }
  }), _c('a', {
    attrs: {
      "id": "i1304"
    }
  }), _c('a', {
    attrs: {
      "id": "i1332"
    }
  }), _c('a', {
    attrs: {
      "id": "i1488"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-27"
    }
  }), _vm._v(" liked to be the first American in space. We knew that selecting the pilot for the first mission was going to be largely a committee decision. Although we weren’t sure who was on the committee, we knew that "), _c('a', {
    attrs: {
      "id": "i797"
    }
  }), _vm._v("Gilruth was one of the influential voices that would be heard. We also weren’t sure of the criteria for the decision. What would it be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("based")]), _vm._v(" on?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the past twenty-one months, we had done so little flying that we had certainly not been able to show anybody what we could really do in the air. So how would they make their choice? Based on how we did on the "), _c('a', {
    attrs: {
      "id": "i232"
    }
  }), _vm._v("centrifuge, or how we might be expected to handle the press and public afterward?")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“But it’s become necessary to make this decision,” Gilruth went on. “And it’s been decided that the prime pilot for the first flight will be—Alan. His backups are John and Gus.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Al looked up, fighting the obvious urge to break out into a big grin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("One by one, we went over to him and shook his hand.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Al Shepard would be the first American in space.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For nearly two years we had worked together like brothers—fiercely competitive, yes, but at the same time very supportive and wanting to see the other guy succeed in every way. That would not change now. Besides, I reminded myself, there would be plenty of other good missions down the road—longer and even "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("better")]), _vm._v(" missions.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent-1"
  }, [_vm._v("The first U.S. manned suborbital mission was delayed for two months after the January 31, 1961, flight of a thirty-seven-pound chimpanzee, Ham, went badly.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Ham survived and was to live to a ripe old age, he endured 18 Gs during reentry and, due to a faulty electrical relay, landed more than a hundred miles off target. By the time the recovery crew reached him, the capsule was on its side filling with water. The nearly drowned chimp emerged in a nasty mood, and I couldn’t blame him."), _c('a', {
    attrs: {
      "id": "i137"
    }
  }), _c('a', {
    attrs: {
      "id": "i246"
    }
  }), _c('a', {
    attrs: {
      "id": "i579"
    }
  }), _c('a', {
    attrs: {
      "id": "i870"
    }
  }), _c('a', {
    attrs: {
      "id": "i1034"
    }
  }), _c('a', {
    attrs: {
      "id": "i1061"
    }
  }), _c('a', {
    attrs: {
      "id": "i1087"
    }
  }), _c('a', {
    attrs: {
      "id": "i1319"
    }
  }), _c('a', {
    attrs: {
      "id": "i1394"
    }
  }), _c('a', {
    attrs: {
      "id": "i1479"
    }
  }), _c('a', {
    attrs: {
      "id": "i1553"
    }
  }), _c('a', {
    attrs: {
      "id": "i1714"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-28"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Al Shepard was convinced that he could have made any necessary corrections and had a better flight than Ham. But to Al’s dismay, it was decided that another test of Redstone with an unmanned Mercury spacecraft was needed before proceeding with the "), _c('a', {
    attrs: {
      "id": "i1035"
    }
  }), _vm._v("first manned shot. Two weeks later, that final test flight went well.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Had Al flown his mission on the originally scheduled date of March 12, 1961, he would have beaten Yuri "), _c('a', {
    attrs: {
      "id": "i717"
    }
  }), _vm._v("Gargarin into space by one month. Instead, we found ourselves further behind the Soviets before we even got started, and Al became the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("second")]), _vm._v(" man in space—twenty days after Gargarin aboard his "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Vostok 1")]), _vm._v(" spacecraft. It was something that still irritated Al years later. “We "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" ’em by the short hairs,” I heard him say a number of times, “and we gave it away.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The first attempt to launch Al was scrubbed two hours before launch due to cloud cover. Three days later, on May 5, 1961, I was serving as CapCom in the blockhouse near the launch pad for the third attempt—following still another weather scrub the previous day. After four hours of frustrating countdown holds, Al was still strapped into his spacecraft on the pad. Everybody was antsy to get going, but one small glitch after another kept popping up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There had been a failed attempt, eleven days earlier, to launch with an Atlas booster a Mercury spacecraft carrying a “mechanical astronaut”—a bunch of black boxes in place of a pilot. The Atlas, which failed to pitch over into the proper trajectory, was destroyed by the range safety officer forty seconds after liftoff. However, the Mercury capsule’s escape rockets worked flawlessly, separating it from the errant rocket, and the spacecraft landed underneath a billowing parachute in the Atlantic just two thousand yards north of the pad.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("We all knew the stakes were much higher this day.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The delay took its toll not only emotionally but in another way. "), _c('a', {
    attrs: {
      "id": "i763"
    }
  }), _c('a', {
    attrs: {
      "id": "i1387"
    }
  }), _c('a', {
    attrs: {
      "id": "i1697"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-29"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gordo!” Al said urgently during still another countdown hold.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Go, Al.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Man, I gotta pee.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("what?”")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Al had been sitting atop the slim black-and-white Redstone rocket for so long that the need to urinate—after his morning coffee and juice at breakfast—was becoming overwhelming. As the suborbital flight was scheduled to last only fifteen minutes, no one had thought it necessary to equip Al or the Mercury spacecraft with a urine collection system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You heard me,” he said. “I’ve got to pee! I’ve been in here forever. The gantry is still right here, so why don’t you guys let me out of here for a quick stretch?”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned around and told the experts the latest glitch.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No way, Al,” I reported back. “They say we don’t have the time to get you out of there and start all over. You’re in there to stay.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Gordo, I’ve got to go!” Al shouted back. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("“I")]), _vm._v(" could be in here a couple more hours. By then, my bladder’s gonna burst!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“They say no.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Al’s famous temper was soaring. “Well shit, Gordo, we’ve got to do "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("something")]), _vm._v("! Dammit, tell ’em I’m going to let it go in my suit!”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Nobody thought that was a real good idea.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“No good, you can’t do that,” I told Al. “The medics say you’ll short-circuit their medical leads.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Tell ’em to switch off the damn power,” Al snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I turned to the experts. There was more discussion—the only wires that urine was likely to come in contact with were low-voltage leads to the medical monitors attached to Al’s body. There was even a sponge mechanism inside the suit designed to sop up any extra moisture, such as perspiration. The experts finally gave the go-ahead."), _c('a', {
    attrs: {
      "id": "i286"
    }
  }), _c('a', {
    attrs: {
      "id": "i861"
    }
  }), _c('a', {
    attrs: {
      "id": "i957"
    }
  }), _c('a', {
    attrs: {
      "id": "i1112"
    }
  }), _c('a', {
    attrs: {
      "id": "i1157"
    }
  }), _c('a', {
    attrs: {
      "id": "i1480"
    }
  }), _c('a', {
    attrs: {
      "id": "i1489"
    }
  }), _c('a', {
    attrs: {
      "id": "i1612"
    }
  }), _c('a', {
    attrs: {
      "id": "i1698"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-30"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“OK,” I said. “Go to it, Al.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Given Al’s position in the spacecraft, the urine pooled in the back of his space suit without soaking any of the sensors on and around his chest area. Later, in his best José Jimenez accent, Al would proclaim himself “de "), _c('a', {
    attrs: {
      "id": "i1036"
    }
  }), _vm._v("first wetback in space.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After that unscheduled pee, the first U.S. manned launch was textbook all the way. Al’s "), _c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "i703"
    }
  }), _vm._v("Freedom 7")]), _vm._v("—the number stood for factory model number 7, the spacecraft delivered by the manufacturer for Al’s flight, not for the seven original astronauts, as most people thought—reached a maximum speed of 5,180 miles per hour, soared to an altitude of 116 miles, and landed 302 miles downrange. The flight lasted fifteen minutes and twenty-two seconds; Al experienced a five-minute period of "), _c('a', {
    attrs: {
      "id": "i1731"
    }
  }), _vm._v("weightlessness and reported no ill effects.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two weeks later our youthful president, John F. Kennedy, told the nation that we would “put a man on the Moon and return him to Earth safely before this decade is out.” It is still the best mission statement of all time, but back then there were a lot of gasps behind closed doors at NASA. Here we were with a total of only fifteen minutes of U.S. manned space flight experience, and we’d never put a man in orbit. President Kennedy’s deadline was two years ahead of the most realistic timetable. We didn’t have the huge rockets that would be needed to get to the Moon or the spacecraft in which to fly there. We didn’t even know how to navigate our way there and back. Don’t get me wrong, I knew it could be done if we put our minds to it—the question was whether all the hardware we needed could be built and tested in time. In spite of the gasps at NASA, everyone was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("elated")]), _vm._v(" to get this kind of public backing from the president on such a big program. Nonetheless, a London bookmaker promptly placed thousand-to-one odds against the Moon landing on JFK’s schedule. (We should all have taken the bet.)")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Gus Grissom was selected to fly the second suborbital mission—a rerun of Al’s fifteen-minute flight—and went up aboard"), _c('a', {
    attrs: {
      "id": "i138"
    }
  }), _c('a', {
    attrs: {
      "id": "i313"
    }
  }), _c('a', {
    attrs: {
      "id": "i448"
    }
  }), _c('a', {
    attrs: {
      "id": "i580"
    }
  }), _c('a', {
    attrs: {
      "id": "i612"
    }
  }), _c('a', {
    attrs: {
      "id": "i1202"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-31"
    }
  }), _vm._v(" "), _c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "i997"
    }
  }), _vm._v("Liberty Bell 7")]), _vm._v(" on July 21, 1961. (Gus kept the number 7 to “honor the team,” and thereafter every Mercury capsule had that symbolic number in its name.) Although he flew a flawless mission, Gus ended up being slaughtered by the media when his capsule, loaded with valuable scientific data, sank in the ocean during recovery efforts. It was the first time in his flying career that Gus had ever lost an aircraft—and it was the only unrecovered U.S. spacecraft—although he and I had nearly bought the farm together earlier in the program.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After the first test of an Atlas rocket carrying an unmanned Mercury capsule went up in flames forty-five seconds into the launch, it was decided to watch the next launch closely from aloft to see if we could spot any obvious problems. Gus and I volunteered to trail the launch in two delta-wing F-106s, keeping the big Atlas company as it gathered speed after liftoff. We would have real grandstand seats. Gus was to approach at five thousand feet, ignite his afterburner, and climb up in a spiral alongside to observe this early phase of its flight. I would take over from the fifteen-thousand-foot level and continue observing the big bird. We both had cameras around our necks with which to take pictures of the rocket at different stages in the flight. I was doing 1.3 Mach and coming around on the Atlas, expecting it to pitch over and begin its arching flight out over the Atlantic. But instead, it kept going straight up. At that instant, the range safety officer in Mercury Control pushed the abort button, which was a proper call on his part. The only problem: no one remembered to warn us. The next thing I knew, the escape tower fired, pulling the capsule right past me—at least "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("that part")]), _vm._v(" worked. The tower and capsule missed my aircraft by no more than fifteen feet, and a fireball was heading up after me. Reacting automatically, I pulled up and over and pointed the nose down, leaving the afterburner on, and ran like a son-of-a-gun to get out of the debris that was falling in chunks. Gus came through the flames and debris below me."), _c('a', {
    attrs: {
      "id": "i7"
    }
  }), _c('a', {
    attrs: {
      "id": "i100"
    }
  }), _c('a', {
    attrs: {
      "id": "i330"
    }
  }), _c('a', {
    attrs: {
      "id": "i613"
    }
  }), _c('a', {
    attrs: {
      "id": "i751"
    }
  }), _c('a', {
    attrs: {
      "id": "i928"
    }
  }), _c('a', {
    attrs: {
      "id": "i1165"
    }
  }), _c('a', {
    attrs: {
      "id": "i1241"
    }
  }), _c('a', {
    attrs: {
      "id": "i1248"
    }
  }), _c('a', {
    attrs: {
      "id": "i1370"
    }
  }), _c('a', {
    attrs: {
      "id": "i1481"
    }
  }), _c('a', {
    attrs: {
      "id": "i1584"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-32"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Somehow, neither of our planes picked up so much as a single metal fragment. It was the last time any of us tried to follow a rocket in a plane.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("From my experience flying with him, I knew Gus was a great pilot. When he returned from his space mission and insisted that he hadn’t blown the hatch early—before navy frogmen had a chance to right the spacecraft and put a floatation collar around it—I believed him. I knew that if he "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("had")]), _vm._v(" screwed up, Gus would have been the "), _c('a', {
    attrs: {
      "id": "i1037"
    }
  }), _vm._v("first to admit it. Instead, he assured us, “I was just lying there minding my own business when—pow!—I saw blue sky and water coming in. It was the biggest shock seeing that hatch go off.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("He was lucky to get out at all with three thousand pounds of sea water pouring through the open hatch. Once he did, he found himself flailing around in the ocean under the roar of helicopter blades as the "), _c('a', {
    attrs: {
      "id": "i1384"
    }
  }), _vm._v("recovery team concentrated on trying to snag the sinking spacecraft before turning their attention to him. “I’m drowning, you bastards!” he yelled up at the helicopter crew, while they waved back and smiled.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("That Gus nearly drowned (his helmet was recovered floating in the ocean next to a ten-foot shark) didn’t seem to matter as much as the rampant speculation among the news media over whether he had blown the hatch early. He wasn’t treated to a parade after his flight, or official celebration from the White House on down, as Al Shepard had been. Although this would undoubtedly have been the case for anyone flying the somewhat anticlimactic second suborbital flight—the media were already getting excited about the upcoming first orbital mission—Gus and his wife, Betty, couldn’t help but feel snubbed by the press, public, and politicians.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Two weeks after Gus’s mission, NASA learned conclusively that Gus had not screwed up when they discovered the real culprit: a design problem with the ignition pin for the hatch, an explanation that was buried on a back page of the "), _c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "i1208"
    }
  }), _vm._v("New York Times.")]), _c('a', {
    attrs: {
      "id": "i247"
    }
  }), _c('a', {
    attrs: {
      "id": "i575"
    }
  }), _c('a', {
    attrs: {
      "id": "i823"
    }
  }), _c('a', {
    attrs: {
      "id": "i862"
    }
  }), _c('a', {
    attrs: {
      "id": "i1203"
    }
  }), _c('a', {
    attrs: {
      "id": "i1296"
    }
  }), _c('a', {
    attrs: {
      "id": "i1320"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-33"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although Gus was subsequently cleared by an official accident review panel, he would continue to be haunted by the incident, thanks to the media. The 1983 movie "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The "), _c('a', {
    attrs: {
      "id": "i1409"
    }
  }), _vm._v("Right Stuff")]), _vm._v(" portrayed him as a panicky oaf who “screwed the pooch” by losing his spacecraft. Most importantly, though, NASA never held the incident against him. In fact, they later gave him the first two-man "), _c('a', {
    attrs: {
      "id": "i719"
    }
  }), _c('a', {
    attrs: {
      "id": "i742"
    }
  }), _vm._v("Gemini flight and scheduled him for the first three-man "), _c('a', {
    attrs: {
      "id": "i43"
    }
  }), _vm._v("Apollo mission. They would have done neither if they believed that Gus had panicked in any way. In July 1999, "), _c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "i998"
    }
  }), _vm._v("Liberty Bell 7")]), _vm._v(" was recovered from the ocean floor—three miles down, deeper than the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Titanic")]), _vm._v("—in a salvage project underwritten by a television network. I don’t know what they will eventually find in the way of physical evidence aboard the spacecraft, but I know that when John "), _c('a', {
    attrs: {
      "id": "i810"
    }
  }), _vm._v("Glenn and Wally "), _c('a', {
    attrs: {
      "id": "i1440"
    }
  }), _vm._v("Schirra blew their hatches on their Mercury missions—signaled to do so by navy frogmen after they’d placed the floatation collars—they ended up with cuts on the palms of their hands from the handle of the hatch-release mechanism snapping back and getting them good. Gus had no such wounds.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The third Mercury flight and first U.S. orbital mission, flown by John Glenn on February 20, 1962, aboard "), _c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "i706"
    }
  }), _vm._v("Friendship 7")]), _vm._v(", put us in the space race for keeps.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("As with the first suborbital flight, this mission was preceded by the launch of a chimpanzee, Enos. Scheduled for three orbits, the spacecraft was brought back after only two orbits due to the failure of an attitude-control thruster jet and the overheating of an inverter in the electrical system. Making matters worse for Enos, each time he responded to a light during the flight and pushed a button as he’d been trained to do, he received not a banana pellet, as he should have, but an electric shock. He was a very pissed-off chimp by the time the hatch was opened. Engineers decided that both of the major problems could have been corrected had an astronaut been aboard, and John was confident that, with or without banana pellets, he could have flown the mission."), _c('a', {
    attrs: {
      "id": "i557"
    }
  }), _c('a', {
    attrs: {
      "id": "i647"
    }
  }), _c('a', {
    attrs: {
      "id": "i707"
    }
  }), _c('a', {
    attrs: {
      "id": "i824"
    }
  }), _c('a', {
    attrs: {
      "id": "i1162"
    }
  }), _c('a', {
    attrs: {
      "id": "i1297"
    }
  }), _c('a', {
    attrs: {
      "id": "i1300"
    }
  }), _c('a', {
    attrs: {
      "id": "i1313"
    }
  }), _c('a', {
    attrs: {
      "id": "i1327"
    }
  }), _c('a', {
    attrs: {
      "id": "i1385"
    }
  }), _c('a', {
    attrs: {
      "id": "i1508"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-34"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Some sixty million people viewed John’s launch on live television. His spacecraft made its three-orbit flight in four hours and fifty-five minutes. Prior to the flight there was concern about the physiological effects of prolonged "), _c('a', {
    attrs: {
      "id": "i1732"
    }
  }), _vm._v("weightlessness. John reported no debilitating or harmful effects, and in fact found the zero gravity conditions very handy in performing his tasks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A faulty switch in the "), _c('a', {
    attrs: {
      "id": "i891"
    }
  }), _vm._v("heat shield circuit indicated that the clamp holding the shield, designed to keep the spacecraft from burning up during reentry, had been prematurely released—information later found to be false. During reentry, the retropack (containing the spent retro rockets used to maneuver in space) was not jettisoned, as the flight plan called for, but retained as an added measure to help hold the heat shield in place in case it had somehow been loosened. That caused some fireworks as the spacecraft reentered the atmosphere and the retropack disintegrated in the intense heat.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("John’s spacecraft landed in the Atlantic eight hundred miles southeast of Bermuda and was recovered by a navy ship after being in the water about twenty minutes. With the success of the flight, we were beginning to achieve the basic objectives of Project Mercury: putting a man into Earth orbit, observing his reactions to the space environment, and returning him safely to Earth in a place where he could be readily found.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("After his flight, John, perfectly at ease as always when it came to dealing with the crush of media attention, became a wonderful spokesman not only for NASA but for America. He did a tremendous amount of good for the program.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The next flight was to have been Deke "), _c('a', {
    attrs: {
      "id": "i1517"
    }
  }), _vm._v("Slayton’s, but he was abruptly grounded for having a detectable heart murmur at high Gs in the "), _c('a', {
    attrs: {
      "id": "i233"
    }
  }), _vm._v("centrifuge. We thought this was extremely unfair, because anyone could be made to have a heart murmur at high enough Gs. Deke was ready to quit, and the rest of us were so upset that we came close to resigning en masse, which would have left America’s space program with no astronauts. We"), _c('a', {
    attrs: {
      "id": "i225"
    }
  }), _c('a', {
    attrs: {
      "id": "i563"
    }
  }), _c('a', {
    attrs: {
      "id": "i689"
    }
  }), _c('a', {
    attrs: {
      "id": "i701"
    }
  }), _c('a', {
    attrs: {
      "id": "i825"
    }
  }), _c('a', {
    attrs: {
      "id": "i1153"
    }
  }), _c('a', {
    attrs: {
      "id": "i1328"
    }
  }), _c('a', {
    attrs: {
      "id": "i1358"
    }
  }), _c('a', {
    attrs: {
      "id": "i1457"
    }
  }), _c('a', {
    attrs: {
      "id": "i1509"
    }
  }), _c('a', {
    attrs: {
      "id": "i1522"
    }
  }), _c('a', {
    attrs: {
      "id": "i1763"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-35"
    }
  }), _vm._v(" finally talked Deke into staying on as head of the astronaut office, a new post in which he would represent our mutual interests. It wasn’t a charity appointment. At the time, there was serious talk of bringing in a general or admiral to fill the new post, but we all agreed that we didn’t need some outside weenie coming in and telling us what to do.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Deke’s backup, "), _c('a', {
    attrs: {
      "id": "i1182"
    }
  }), _vm._v("navy pilot Scott Carpenter, was given the next orbital mission, although he didn’t have much time to practice for it in the simulator as prime pilot. Scott was launched on May 24, 1962, aboard his "), _c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "i143"
    }
  }), _vm._v("Aurora 7")]), _vm._v(" spacecraft and replicated John Glenn’s three-orbit mission. Things didn’t go well almost from the beginning. Scott used more fuel for the attitude-control thrusters than planned due to a faulty automatic stabilization system, and had to drift for most of his final orbit. Scott got caught up in some scientific experiments and wasn’t ready for his retro-fire. He fired late, and overshot the recovery area by two hundred and fifty miles. After spending more than an hour inside the hot cabin, he wiggled out of the narrow top of the tower rather than blow off the hatch and risk the capsule’s sinking. He spent more hours on his raft before being picked up by a helicopter. N"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OT")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ONFUSED:")]), _vm._v(" C"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ARPENTER")]), _vm._v(" blasted one headline. Scott, who knew he had screwed up, took some heat. He never flew in space again, and when the opportunity arose to become involved in the navy’s Sea Lab research project, he quietly resigned from NASA and ended up doing a fantastic job in the undersea exploration program.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Next up was Wally Schirra, another top navy pilot. Wally believed in training himself hard, and was very precise. After his launch on October 3, 1962, aboard "), _c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "i1496"
    }
  }), _vm._v("Sigma 7")]), _vm._v(", Wally experienced problems with his pressure suit that almost brought him back to Earth after only one orbit, but he was able to solve the difficulties in flight and sailed on for six orbits. His mission was considered a textbook engineering flight and went so well that NASA decided to advance the flight schedule."), _c('a', {
    attrs: {
      "id": "i292"
    }
  }), _c('a', {
    attrs: {
      "id": "i1064"
    }
  }), _c('a', {
    attrs: {
      "id": "i1154"
    }
  }), _c('a', {
    attrs: {
      "id": "i1314"
    }
  }), _c('a', {
    attrs: {
      "id": "i1323"
    }
  }), _c('a', {
    attrs: {
      "id": "i1458"
    }
  }), _c('a', {
    attrs: {
      "id": "i1497"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-36"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The original Mercury launch schedule had provided for two six-orbit missions before trying for the first one-day mission, but after Wally’s flight, NASA decided to jump to the one-day mission—and it was to be "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mine.")]), _vm._v(" Eighteen orbits were the goal, but if the flight met all expectations, Mercury Control would extend the mission to twenty-two orbits—leaving me in space for approximately a day and a half.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("New state-of-the-art design modifications had been made to my spacecraft to accommodate life-support and functional demands for more than a day in space. Since weight was extremely critical, attention was first given to removal of any unnecessary hardware and systems. The periscope (nothing more than a sightseeing device) had already been removed from the spacecraft for Wally’s flight. For my flight they undertook a complete "), _c('a', {
    attrs: {
      "id": "i1740"
    }
  }), _vm._v("weight reduction program—measuring the payload not in pounds but in tenths of pounds. The manual rate stabilization and control system—like an autopilot that kept constantly adjusting the spacecraft’s attitude with thruster rockets—turned out to be unnecessary and a glutton for fuel, so it was removed. A lighter-weight pilot’s couch was installed. Nine extra pounds of water, about a gallon and a half, were added to the cooling system, and four pounds of additional liquid oxygen augmented the breathing stores. I was scheduled to drink voluminous amounts of water for "), _c('a', {
    attrs: {
      "id": "i1699"
    }
  }), _vm._v("urine analysis, which NASA physiologists thought would be the best way to monitor chemical reactions that might occur within the body during a period of prolonged "), _c('a', {
    attrs: {
      "id": "i1733"
    }
  }), _vm._v("weightlessness, so five additional pounds of drinking water were added. Electrical battery power was doubled. A "), _c('a', {
    attrs: {
      "id": "i1618"
    }
  }), _vm._v("television camera—the first to go into space—was installed to prove the feasibility of TV in space and to record ground scenes as well as onboard life.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had been given three main priorities for the flight: prove that a pilot could go off automatic control and fly the spacecraft efficiently; capably manage the use of all onboard consumables,"), _c('a', {
    attrs: {
      "id": "i208"
    }
  }), _c('a', {
    attrs: {
      "id": "i440"
    }
  }), _c('a', {
    attrs: {
      "id": "i505"
    }
  }), _c('a', {
    attrs: {
      "id": "i591"
    }
  }), _c('a', {
    attrs: {
      "id": "i1270"
    }
  }), _c('a', {
    attrs: {
      "id": "i1315"
    }
  }), _c('a', {
    attrs: {
      "id": "i1535"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-37"
    }
  }), _vm._v(" such as fuel for the attitude-control thrusters, electricity, oxygen, and water; and conduct scientific experiments to aid development of rendezvous techniques, which would be vital in the upcoming lunar missions.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("NASA had another top priority for the mission: “determining the effects of extended space flight on man.” Many doctors and scientists were convinced that the pooling of blood in a person’s extremities during zero gravity would preclude space flights of more than a few hours. The sickness that the Russian cosmonauts were reported to have experienced on their long-duration flights increased the concern.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("When it came to naming my spacecraft, I felt a responsibility to find the right name. I knew that an awful lot of thought and symbolism had gone into the earlier names, and I finally selected "), _c('em', {
    staticClass: "italic"
  }, [_c('a', {
    attrs: {
      "id": "i616"
    }
  }), _vm._v("Faith")]), _vm._v(" 7, which was painted on the side of the spacecraft. The name would symbolize my faith in the launch team, my faith in all the hardware that had been so carefully tested, my faith in myself, and my faith in God.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Four years and five months after volunteering for the manned space program in that crowded NASA briefing room, I was about to get my chance. But not before a close call—nearly getting bumped from the mission at the last minute by an angry Walt "), _c('a', {
    attrs: {
      "id": "i1757"
    }
  }), _vm._v("Williams, Project Mercury operations director and NASA’s number three guy.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I had been the one to get angry first. When I arrived at "), _c('a', {
    attrs: {
      "id": "i873"
    }
  }), _vm._v("Hangar S the day before launch, I saw to my disbelief that a last-minute modification had been made to my custom-made pressure suit. The medical people had cut a hole in it and inserted a metal fitting in the chest for an additional monitor, which they could automatically inflate any time they wanted to during the flight to check my blood pressure. This violated a firm rule we had against doing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anything")]), _vm._v(" to an astronaut’s pressure suit just before a flight. What if the new fitting leaked? I might not discover that my suit wasn’t holding pressure until I was in space and needed it."), _c('a', {
    attrs: {
      "id": "i209"
    }
  }), _c('a', {
    attrs: {
      "id": "i538"
    }
  }), _c('a', {
    attrs: {
      "id": "i609"
    }
  }), _c('a', {
    attrs: {
      "id": "i1038"
    }
  }), _c('a', {
    attrs: {
      "id": "i1482"
    }
  }), _c('a', {
    attrs: {
      "id": "i1490"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-38"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I hit the roof, and was still venting when I took an F-102 aloft for what had become a day-before-launch ritual to allow an astronaut—feeling overworked and overprepared about now—to have a little fun. I pushed the supersonic fighter hard through loops and dives. Then I dove for the deck. As I zoomed past "), _c('a', {
    attrs: {
      "id": "i874"
    }
  }), _vm._v("Hangar S only a few feet off the ground, Williams happened to step from a doorway, only to see himself eyeball-to-eyeball with a streaking jet fighter. At that instant, I lit the afterburner. I heard later that Williams dropped the stack of papers he was holding and grabbed at his throat as if to keep his heart from leaping out of his chest. He went from quivering to an uncontrolled rage. The condemnations, which came to me secondhand because Williams was unwilling to confront me directly, went on until well into the evening. A stern man by nature, Williams insisted in no uncertain terms that I was "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("off ")]), _vm._v("the mission and ordered Al Shepard, my backup, to take the flight. Al had been aggressively seeking a chance to get into space since his fifteen-minute suborbital flight, which now paled in comparison with the longer missions being flown, and was very happy to do so. This came as no surprise to me because I knew this side of Al, who was not to be trusted when it came to anything that he considered in his best interests.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Williams had long believed I was not taking things seriously enough. He’d come from being chief of operations at Edwards for NASA’s rocket plane programs—X-1, X-2, and X-3—and was accustomed to dealing with serious and studious research types, not fighter jocks. I guess I just rubbed him the wrong way, because much earlier he’d raised with Deke "), _c('a', {
    attrs: {
      "id": "i1518"
    }
  }), _vm._v("Slayton the subject of giving Shepard the nod over me. “Walt thinks you’re a hot dog and maverick and that you bend the rules too much,” Deke had told me. I’d given Deke my best “Who, me?” look. Had it been all those speeding tickets in Cocoa Beach? Or my racing at Daytona International Speedway? Or maybe running the world-class speedboats? Sometime later Deke told me"), _c('a', {
    attrs: {
      "id": "i431"
    }
  }), _c('a', {
    attrs: {
      "id": "i441"
    }
  }), _c('a', {
    attrs: {
      "id": "i840"
    }
  }), _c('a', {
    attrs: {
      "id": "i983"
    }
  }), _c('a', {
    attrs: {
      "id": "i1077"
    }
  }), _c('a', {
    attrs: {
      "id": "i1271"
    }
  }), _c('a', {
    attrs: {
      "id": "i1284"
    }
  }), _c('a', {
    attrs: {
      "id": "i1324"
    }
  }), _c('a', {
    attrs: {
      "id": "i1389"
    }
  }), _c('a', {
    attrs: {
      "id": "VPS-39"
    }
  }), _vm._v(" that President "), _c('a', {
    attrs: {
      "id": "i949"
    }
  }), _vm._v("Kennedy, whom I’d met more than a dozen times, had gotten wind that I might be passed over and had made it clear to NASA that he would have none of it. It’s good to have friends in high places.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Now I’d gone and given "), _c('a', {
    attrs: {
      "id": "i1758"
    }
  }), _vm._v("Williams the opening he was looking for.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The other five astronauts backed me, saying that the medical people had caused the problem in the first place by tampering with my suit at the last moment. But after four years of nonstop training and preparations, I found myself facing the possibility that I might lose my shot. The wait was agonizing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Then, about ten o’clock the night before the launch, I got the word that Walt Williams had relented.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The mission was still mine.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-60e08896","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/Chapter_01.vue
// module id = 72
// module chunks = 0